<div class="mat-elevation-z0">
  <mat-form-field>
    <button matPrefix mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>
    <input matInput placeholder="{{'COMMON.SEARCH' | translate}}" [formControl]="filterControl" (input)="searchType($event.target.value)">
    <button matSuffix mat-icon-button *ngIf="filterControl.value" (click)="filterControl.setValue('')">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-slide-toggle [checked]="hideUnselected" (change)="hideUnselectedToggle($event.checked)" class="slider">
    Hide Unselected
  </mat-slide-toggle>
  <table mat-table class="full-width-table" matSort aria-label="Elements">
    <!-- Id Column -->

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()"
                      [disabled]="disabled">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)"
                      [disabled]="disabled">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SPECIFICATION.FACTORS' | translate}}</th>
      <td mat-cell *matCellDef="let row">{{row.title}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</div>
